export default __webpack_public_path__ + "static/media/background.932e36bb.jpg";